(function () {
  'use strict';

  angular.module('app.setup-account', []);

})();